import { render, staticRenderFns } from "./BeeCurrenciesAutocomplete.vue?vue&type=template&id=ed4ec6c2&"
import script from "./BeeCurrenciesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BeeCurrenciesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports